module.exports = __webpack_public_path__ + "img/block-bg-dark.830ad9d1.png";